import {
  COLLECT_AM,
  COLLECT_CEO,
  COLLECT_FINANCE,
  COLLECT_RECRUITER,
  COLLECT_SALES,
} from "./collect";
import { DE_ONBOARDING } from "./de-onboarding";
import { SEAT_SETUP } from "./seat-setup";
import type { FlowDef, FlowKey } from "./types";

export * from "./collect";
export * from "./de-onboarding";
export * from "./engine";
export * from "./onboarding-intake";
export * from "./seat-setup";
export * from "./types";

export const FLOWS: Readonly<Record<FlowKey, FlowDef>> = {
  seat_setup: SEAT_SETUP,
  de_onboarding: DE_ONBOARDING,
  collect_ceo: COLLECT_CEO,
  collect_am: COLLECT_AM,
  collect_recruiter: COLLECT_RECRUITER,
  collect_sales: COLLECT_SALES,
  collect_finance: COLLECT_FINANCE,
};

export const FLOW_KEYS = Object.keys(FLOWS) as FlowKey[];

export function flowDef(key: string): FlowDef | null {
  return (FLOWS as Record<string, FlowDef>)[key] ?? null;
}
